'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _taReactTrackingpixel = require('ta-react-trackingpixel');

var _taReactTrackingpixel2 = _interopRequireDefault(_taReactTrackingpixel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file NewsnetTracker component class to render an invisible pixel image
 * that tracks the hits on the page.
 */

var NewsnetTracker = function NewsnetTracker(props) {

  if (!props.articleId) {
    return null;
  }

  return _react2.default.createElement(_taReactTrackingpixel2.default, {
    url: 'http://www.tagesanzeiger.ch/' + props.articleId + '/pixel.gif?nocache=' + Math.random() * 100000 });
};

NewsnetTracker.propTypes = {
  /**
   * The article ID as displayed in CD.
   */
  articleId: _react2.default.PropTypes.string.isRequired
};

exports.default = NewsnetTracker;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-newsnettracker/dist/index.js
// module id = 392
// module chunks = 0